export const getInitials = (user: { attributes: { given_name: string; family_name: string } }) =>
  user?.attributes?.given_name?.substring(0, 1)?.toUpperCase() +
  user.attributes?.family_name?.substring(0, 1)?.toUpperCase();
